import Empty from "@/views/Empty.vue";
import CardsRedirect from "@/components/Common/Cards/CardsRedirect.vue";

export default {
  path: "cards",
  name: "cards",
  component: Empty,
  children: [
    {
      name: "redirect",
      path: "redirect",
      component: CardsRedirect
    }
  ]
};